import { eventBus } from "@/utils/eventBus";

export default {
  methods: {
    successToast(description, message = "Success") {
      eventBus.$emit("show-toast", {
        message,
        description,
        type: "success",
      });
    },
    errorToast(description, message = "Error") {
      eventBus.$emit("show-toast", {
        message,
        description,
        type: "danger",
      });
    },
    warningToast(description, message) {
      eventBus.$emit("show-toast", {
        message,
        description,
        type: "warning",
      });
    },
  },
};
